/* Packages */
import React, { useEffect, useRef } from 'react';
import Form from 'react-bootstrap/Form';
import { useFormContext } from 'react-hook-form';

/* Hooks */
import useValidation from 'conversie-flow-bundle/assets/js/components/flow/hooks/useValidation';
import useFlowContext from "conversie-flow-bundle/assets/js/components/flow/hooks/useFlowContext";

export default function ConversionFieldUpload(props) {
    const { colClassName, field, component, path, id, addFiles, removeFiles } = props;
    const { type, label, required, disabled, value, name, accept, multiple } = field;
    const fileInputRef = useRef(null);
    const files = component?.metadata?.[name] || [];

    const form = useFormContext();

    const {
        translate = () => { },
    } = useFlowContext();

    const {
        setValue = () => { },
        trigger = () => { },
        formState = {},
    } = form || {};

    const { isSubmitted } = formState;

    const { error } = useValidation({ path, ...field, ...form });

    const requiredText = translate(`webstores_conversion_flow.common.required_field`);

    useEffect(() => {
        setValue(path, value);
    }, [value]);

    const handleFileChange = (e) => {
        const selectedFiles = e?.target?.files;

        removeFiles(value, () => {
            addFiles(selectedFiles, () => {
                trigger(path);
            });
        });
    };

    const handleRemoveFile = (fileToRemove) => {
        const currentFiles = files || [];
        const remainingFiles = currentFiles.filter(file => file.id !== fileToRemove.id);

        removeFiles(value, () => {
            if (remainingFiles.length > 0) {
                addFiles(remainingFiles, () => {
                    trigger(path);
                });
            } else {
                trigger(path);
            }
        });

        if (fileInputRef.current) {
            fileInputRef.current.value = '';
        }
    };

    return (
        <div className={`${ colClassName }`}>
            <Form.Group controlId={id} className={`form-label-group form-group--flow form-group--flow-field-${ type } form-group--flow-${ name }`}>
                {required === true && requiredText.length !== 0 &&
                    <span className="required-label">{requiredText}</span>
                }

                <Form.File
                    ref={fileInputRef}
                    custom
                    className="d-none"
                    id={id}
                    name={id}
                    accept={accept}
                    multiple={multiple}
                    required={required}
                    disabled={disabled}
                    onChange={handleFileChange}
                />

                <button
                    type="button"
                    className={`btn btn-outline-base text-truncate btn-block ${error || (isSubmitted && required && (!files || files.length === 0)) ? 'is-error' : ''}`}
                    onClick={() => !disabled && fileInputRef.current?.click()}
                    disabled={disabled}
                    title={label}
                >
                    <span className="btn__text">
                        {label}
                    </span>
                </button>

                {files?.length > 0 && (
                    <div className="mt-2">
                        {files.map((file, index) => (
                            <div key={index} className="d-flex align-items-center mb-1">
                                <small className="text-muted text-truncate flex-shrink-1" style={{ minWidth: 0 }}>
                                    {file.name}
                                </small>
                                <small className="text-muted ml-2 flex-shrink-0">
                                    -
                                    <button
                                        type="button"
                                        className="btn btn-link btn-sm p-0 ml-1"
                                        onClick={() => handleRemoveFile(file)}
                                        disabled={disabled}
                                        style={{ textDecoration: 'underline', fontSize: 'inherit' }}
                                    >
                                        verwijderen
                                    </button>
                                </small>
                            </div>
                        ))}
                    </div>
                )}

                {error && (
                    <Form.Control.Feedback type="invalid">
                        {error}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
        </div>
    );
}
